var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Router } from "@angular/router";
import { ToasterService } from "angular2-toaster";
import { CommonService } from "app/services";
import { OnDestroy, OnInit } from "@angular/core";
import { BsModalService } from "ngx-bootstrap";
import { Subscription } from "rxjs";
import { AppService } from "app/services/app.service";
var NewJoinOfferButtonComponent = /** @class */ (function () {
    function NewJoinOfferButtonComponent(modalService, commonService, toaster, router, appService) {
        this.modalService = modalService;
        this.commonService = commonService;
        this.toaster = toaster;
        this.router = router;
        this.appService = appService;
        this.isLoading = false;
        this.isScraping = false;
        this.joinrsAiResponse = null;
        this.linkValid = false;
        this.errors = [];
        this.link = "";
        this.isDisabled = null;
    }
    NewJoinOfferButtonComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._reset();
        this._obs$ = this.appService
            .getJobStatus()
            .subscribe(function (r) { return (_this.isDisabled = r); });
    };
    NewJoinOfferButtonComponent.prototype._reset = function () {
        this.isLoading = false;
        this.isScraping = false;
        this.joinrsAiResponse = null;
        this.linkValid = false;
        this.errors = [];
    };
    NewJoinOfferButtonComponent.prototype.ngOnDestroy = function () {
        this._obs$.unsubscribe();
    };
    NewJoinOfferButtonComponent.prototype.openModal = function () {
        if (this.isDisabled && this.isDisabled.exceeded) {
            this.toaster.pop("error", "Error", "Jobs active limit excedeed\nCurrent: " + this.isDisabled.current + "\nMax: " + this.isDisabled.max);
            return;
        }
        else {
            this.router.navigate(["recruiting", "new"]);
        }
    };
    NewJoinOfferButtonComponent.prototype.joinrsAi = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.isScraping = true;
                        return [4 /*yield*/, new Promise(function (resolve) {
                                setTimeout(function () {
                                    resolve(true);
                                }, 3000);
                            })];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        _a = this.commonService;
                        _b = [{}];
                        return [4 /*yield*/, this.commonService.getJobFromUrl(this.link).toPromise()];
                    case 3:
                        _a.jobFromUrl = __assign.apply(void 0, _b.concat([(_c.sent()), { _scraping_url: this.link }]));
                        this.modalRef.hide();
                        this.router.navigate(["recruiting", "new"]);
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _c.sent();
                        this._reset();
                        this.errors.push("We were unable to extract the data from the inserted link but you can proceed manually and create a join offer by clicking on the button.");
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    NewJoinOfferButtonComponent.prototype.linkChange = function ($event) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                this.isLoading = true;
                try {
                    url = new URL($event.target.value);
                    this.linkValid = true;
                    this.isLoading = false;
                }
                catch (e) {
                    this.linkValid = false;
                    this.isLoading = false;
                }
                return [2 /*return*/];
            });
        });
    };
    return NewJoinOfferButtonComponent;
}());
export { NewJoinOfferButtonComponent };
